import {NgModule} from '@angular/core';
import {NavigationEnd, Router, RouterModule, Routes, RoutesRecognized} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {SearchComponent} from './search/search.component';
import {SearchListComponent} from './search/search-list/search-list.component';
import {ObjectDetailComponent} from './search/object-detail/object-detail.component';
import {DescriptorComponent} from './descriptor/descriptor.component';
import {MaterializationComponent} from './search/object-detail/materialization/materialization.component';
import {LogRoutingService} from './log/log-routing.service';
import {LogModule} from './log/log.module';
import {filter} from 'rxjs/operators';
import {BreadcrumbModule} from './breadcrumb/breadcrumb.module';
import {BreadCrumbLocalStorageService} from './breadcrumb/bread-crumb-local-storage.service';
import {InfoPageComponent} from './info-pages/info-page/info-page.component';
import {ObjectExistsGuard} from './guard-module/object-exists/object-exists.guard.service';
import {Page404Component} from './guard-module/http-status/page404/page404.component';
import {Page400Component} from './guard-module/http-status/page400/page400.component';
import {InfoPageService} from './info-pages/info-page.service';
import {BrowseListComponent} from './search/browse-list/browse-list.component';
import {AccountComponent} from './auth/account/account/account.component';
import {Page401Component} from './guard-module/http-status/page401/page401.component';
import {UserCollectionsComponent} from './auth/account/user-collections/user-collections.component';
import {UserCollectionComponent} from './auth/account/user-collections/user-collection/user-collection.component';
import {UserQueriesComponent} from './auth/account/user-queries/user-queries.component';
import {GoogleAnalyticsService} from './shared/google-analytics.service';
import {InstitutionsComponent} from './institutions/institutions.component';
import {Title} from '@angular/platform-browser';
import {SiteMapComponent} from './site-map/site-map.component';
import {QueryComponent} from './query/query.component';
import {PublicDataViewComponent} from './public-data-view/public-data-view.component';
import {LoginComponent} from "./login/login.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {RegistrationComponent} from "./registration/registration.component";


export const routes: Routes = [
  {path: '', component: HomeComponent},
  {
    path: '',
    component: SearchComponent,
    children: [
      {path: 'account', component: AccountComponent},
      {path: 'collections', component: UserCollectionsComponent},
      {path: 'collection', component: UserCollectionComponent},
      {path: 'queries', component: UserQueriesComponent},
      {path: InfoPageService.BASE_PREFIX + '/:pageName', component: InfoPageComponent},
      {path: 'search/s', component: SearchListComponent},
      {path: 'search/b', component: BrowseListComponent},
      {path: 'detail/:type/:id', component: ObjectDetailComponent, canActivate: [ObjectExistsGuard]},
      {path: 'work/:id', redirectTo: 'detail/work/:id'},
      {path: 'museum_object/:id', redirectTo: 'detail/museum_object/:id'},
      {path: 'archive_object/:id', redirectTo: 'detail/archive_object/:id'},
      {path: 'work_materialization/:id', redirectTo: 'detail/work_materialization/:id'},
      {path: 'materialization/:id', component: MaterializationComponent},
      {path: 'public_dataset/:id', component: PublicDataViewComponent},
      {path: 'institutions', component: InstitutionsComponent},
      {path: 'sitemap', component: SiteMapComponent},
      {path: 'sparql-endpoint', component: QueryComponent},
      {path: 'login', component: LoginComponent},
      {path: 'register', component: RegistrationComponent},
      {path: 'reset-password', component: ResetPasswordComponent},
      {path: ':type/:id', component: DescriptorComponent, canActivate: [ObjectExistsGuard]},
      {path: '404', component: Page404Component},
      {path: '401', component: Page401Component},
      {path: '400', component: Page400Component},
      {path: '**', component: Page404Component}
    ]
  },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: false,
  }), LogModule, BreadcrumbModule],
  exports: [RouterModule]
})
export class AppRoutingModule {

  gtag: Function;

  constructor(private router: Router,
              private logService: LogRoutingService,
              private breadService: BreadCrumbLocalStorageService,
              private googleAnalyticsService: GoogleAnalyticsService,
              private titleService: Title) {
    this.router.events
      .pipe(
        filter((e: any) => e instanceof NavigationEnd)
      ).subscribe((e: RoutesRecognized) => {
      this.googleAnalyticsService.trackPage(e.urlAfterRedirects, this.titleService.getTitle());
      this.logService.addLog(e);
      this.breadService.getBreadcrumbs(e);
    });
  }

}
